import { IconDefinition } from "./types";

const cross: IconDefinition = {
  iconName: "cross",
  width: 16,
  height: 16,
  svgPathData: "M14 2L2 14M14 14L2 2",
  iconType: "stroke",
};

export { cross };
